import React, { useState } from 'react';
import TurkeyMap from 'turkey-map-react';
import { useTheme } from '../context/ThemeContext';
import { MapPin, Tag } from 'lucide-react';

const partners = [
  "İstanbul", "Ankara", "Bursa", "Denizli", "Aydın", 
  "Isparta", "Afyonkarahisar", "Gaziantep", "Van", "Konya","Antalya","Manisa","Sivas","Kocaeli","Muğla","İzmir","Samsun"
];

const InteractiveMap = () => {
  const { isDarkMode } = useTheme();
  const [hoveredCity, setHoveredCity] = useState(null);
  
  const idleColor = isDarkMode ? "#374151" : "#e5e7eb";
  const hoverEmptyColor = isDarkMode ? "#4b5563" : "#d1d5db";

  const handleHover = (city) => {
    setHoveredCity(city);
  };

  const renderCity = (cityComponent, cityData) => {
    const isPartner = partners.includes(cityData.name);

    return (
      <g 
        key={cityData.id} 
        onMouseEnter={() => handleHover(cityData)}
        onMouseLeave={() => setHoveredCity(null)}
        className={`cursor-pointer ${isPartner ? 'partner-city' : 'regular-city'}`}
      >
        {cityComponent}
      </g>
    );
  };

  return (
    <div className="w-full flex flex-col items-center relative py-8 map-container">
      <style>
        {`
          /* Override fill colors for partner cities */
          .partner-city path {
            fill: #22c55e !important;
            transition: fill 0.3s ease;
          }
          .partner-city:hover path {
            fill: #16a34a !important;
          }
          
          /* Add transition to regular cities as well */
          .regular-city path {
            transition: fill 0.3s ease;
          }
        `}
      </style>

      {/* Tooltip Area */}
      <div className="h-24 md:h-16 flex items-center justify-center w-full mb-4 px-4">
        {hoveredCity ? (
          <div className={`px-6 py-3 rounded-2xl flex items-center gap-3 shadow-lg transition-all animate-slide-up ${
            partners.includes(hoveredCity.name) 
              ? 'bg-primary-50 dark:bg-primary-900/40 text-primary-700 dark:text-primary-300 border border-primary-200 dark:border-primary-800'
              : 'bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 border border-gray-200 dark:border-gray-700'
          }`}>
            {partners.includes(hoveredCity.name) ? (
              <>
                <MapPin className="text-primary-500 animate-bounce" size={24} />
                <div>
                  <div className="font-bold text-lg">{hoveredCity.name}</div>
                  <div className="text-sm font-medium">Bu şehirde iş partnerlerimiz var!</div>
                </div>
              </>
            ) : (
              <>
                <Tag className="text-amber-500 animate-pulse" size={24} />
                <div>
                  <div className="font-bold text-lg">{hoveredCity.name}</div>
                  <div className="text-sm font-medium text-amber-600 dark:text-amber-400">Bu şehirden ilk müşterimize net %20 indirim!</div>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="px-6 py-3 rounded-2xl bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 border border-transparent flex items-center gap-2">
            <MapPin size={20} />
            <span className="font-medium text-sm md:text-base">Detayları görmek için haritada bir şehrin üzerine gelin.</span>
          </div>
        )}
      </div>

      {/* Map Container */}
      <div className="w-full overflow-x-auto overflow-y-hidden pb-4 custom-scrollbar">
        <div className="min-w-[750px] max-w-[1000px] w-full px-4 md:mx-auto">
          <TurkeyMap
            hoverable={true} 
            cityWrapper={renderCity}
            customStyle={{ idleColor, hoverColor: hoverEmptyColor }}
          />
        </div>
      </div>
      
      {/* Legend */}
      <div className="flex items-center gap-6 mt-8 flex-wrap justify-center">
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-primary-500"></span>
          <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Aktif Şehirler</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-gray-200 dark:bg-gray-700" style={{ backgroundColor: idleColor }}></span>
          <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Fırsat Şehirleri (%20 İndirim)</span>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMap;
